import { render } from "./ObjectiveListPage.vue?vue&type=template&id=852b0ae8&scoped=true"
import script from "./ObjectiveListPage.vue?vue&type=script&lang=js"
export * from "./ObjectiveListPage.vue?vue&type=script&lang=js"

import "./ObjectiveListPage.vue?vue&type=style&index=0&id=852b0ae8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-852b0ae8"]])

export default __exports__